import { DollarSign } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function CallChargePanel({ price }: { price?: number | null }) {
  const { t } = useTranslation('calls')
  const isPending = price == null
  return (
    <div className="rounded-xl border border-border bg-surface-elevated p-5">
      <div className="flex items-center gap-2">
        <DollarSign className="h-4 w-4 text-primary" />
        <h3 className="text-base font-semibold text-text-primary">{t('detail.charge.title')}</h3>
        <span className="ml-auto font-mono text-base font-semibold text-text-primary">
          {isPending ? t('detail.charge.pending') : `$${price.toFixed(4)}`}
        </span>
      </div>
    </div>
  )
}
